"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const TransitionRenderer_1 = __importDefault(require("../../../ControlRenderer/components/TransitionRenderer"));
const ApplicationContext_1 = __importDefault(require("../../../PageBooter/ApplicationContext"));
const computeComplexUnit_1 = __importDefault(require("../../../ControlStyleFormaters/shared/computeComplexUnit"));
const executeTransition_1 = __importDefault(require("../../../shared/executeTransition"));
const style_1 = __importDefault(require("./style"));
const BottomMenuSheetWrapperRenderer = ({ page, children, }) => {
    var _a, _b, _c;
    const { bottomMenuContext } = (0, react_1.useContext)(ApplicationContext_1.default);
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const transitionWrapper = (0, react_1.useMemo)(() => {
        if ((bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.transition) && bottomMenuContext.speed) {
            return ({
                type: bottomMenuContext.transition === 'SlideTop' ? 'FadeIn' : 'FadeOut',
                speed: bottomMenuContext.speed,
            });
        }
        return undefined;
    }, [bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.transition, bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.speed]);
    const transitionBottomMenu = (0, react_1.useMemo)(() => {
        if ((bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.transition) && bottomMenuContext.speed) {
            return ({
                type: bottomMenuContext.transition,
                speed: bottomMenuContext.speed,
            });
        }
        return undefined;
    }, [bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.transition, bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.speed]);
    const bottomMenuHeight = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        let newHeight = '80%';
        if ((_b = (_a = page.bottomMenuSheet) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.height) {
            newHeight = (0, computeComplexUnit_1.default)((() => undefined))((_d = (_c = page.bottomMenuSheet) === null || _c === void 0 ? void 0 : _c.style) === null || _d === void 0 ? void 0 : _d.height);
        }
        return newHeight;
    }, [(_b = (_a = page.bottomMenuSheet) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.height]);
    const handleRequestBottomMenuClose = (0, react_1.useCallback)(() => {
        if ((bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.transition) && (bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.speed)) {
            processor.root.setTransitionBottomMenu({
                type: 'SlideTopOut',
                speed: bottomMenuContext.speed,
            });
            (0, executeTransition_1.default)(bottomMenuContext.speed).then(() => {
                processor.root.setIsBottomMenuOpened(false);
                processor.root.isBottomMenuOpened = false; // eslint-disable-line
            });
        }
        else {
            processor.root.setIsBottomMenuOpened(false);
            processor.root.isBottomMenuOpened = false; // eslint-disable-line
        }
    }, [processor, bottomMenuContext]);
    if (!((_c = page.bottomMenuSheet) === null || _c === void 0 ? void 0 : _c.active) || !(bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext.isOpened)) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TransitionRenderer_1.default, { transition: transitionWrapper, style: style_1.default.wrapper },
            react_1.default.createElement(Render.TouchableOpacity, { onPress: handleRequestBottomMenuClose, style: style_1.default.touchBottomMenu })),
        react_1.default.createElement(TransitionRenderer_1.default, { transition: transitionBottomMenu, style: style_1.default.transitionBottomMenu(bottomMenuHeight) }, children)));
};
exports.default = BottomMenuSheetWrapperRenderer;
